export const KB_CATEGORIES = {
  application: {
    label: "Application",
    color: "#7C3AED",
    bg: "#F5F3FF",
    border: "#DDD6FE",
    icon: "cpu",
  },
  database: {
    label: "Database",
    color: "#B45309",
    bg: "#FFFBEB",
    border: "#FDE68A",
    icon: "database",
  },
  network: {
    label: "Network",
    color: "#0369A1",
    bg: "#F0F9FF",
    border: "#BAE6FD",
    icon: "network",
  },
  infrastructure: {
    label: "Infrastructure",
    color: "#15803D",
    bg: "#F0FDF4",
    border: "#BBF7D0",
    icon: "server",
  },
  other: {
    label: "Other",
    color: "#6B7280",
    bg: "#F9FAFB",
    border: "#E5E7EB",
    icon: "layers",
  },
};

export function getKBCategory(issueType) {
  const t = (issueType || "").toLowerCase();
  if (
    t.includes("app") ||
    t.includes("code") ||
    t.includes("deploy") ||
    t.includes("service") ||
    t.includes("api") ||
    t.includes("crash") ||
    t.includes("oom")
  )
    return "application";
  if (
    t.includes("db") ||
    t.includes("database") ||
    t.includes("sql") ||
    t.includes("mongo") ||
    t.includes("redis") ||
    t.includes("query")
  )
    return "database";
  if (
    t.includes("net") ||
    t.includes("dns") ||
    t.includes("tcp") ||
    t.includes("latency") ||
    t.includes("timeout") ||
    t.includes("firewall") ||
    t.includes("bandwidth")
  )
    return "network";
  if (
    t.includes("disk") ||
    t.includes("cpu") ||
    t.includes("memory") ||
    t.includes("server") ||
    t.includes("hardware") ||
    t.includes("storage") ||
    t.includes("infra") ||
    t.includes("host")
  )
    return "infrastructure";
  return "other";
}
